import React from "react";

const Home = () => {
  return (
    <div className="animate-fadeIn">
      <img
        className="canopy-page-home-logo"
        src="/Logo.png"
        alt="Greenlight Financial"
      />
    </div>
  );
};

export default Home;
